<template>
    <div id="inspire" style="word-break: normal;">
        <v-container fluid class="d-none d-sm-flex justify-sm-start">
            <!--style="position:fixed;top:0;left:0;z-index:1;background-color:#fff;">-->
            <v-row justify="center"
                   no-gutters>
                <v-col
                        align-self="center"
                        cols="2"
                        class="text-center"
                >
                    <img src="https://zzitec-hosp-prd.oss-cn-shanghai.aliyuncs.com/public/zzOfficeWeb/zz_logo%402x.png?OSSAccessKeyId=LTAI3mUS3TOsECzW&Expires=10001590131189&Signature=tbunLtv8LUATGAN0zfzmqEshx7Q%3D"
                         class="heardImg" alt="">
                </v-col>
                <v-col
                        align-self="center"
                        cols="8">
                    <span class="pl-4 pr-4 mr-6"
                          v-for="(item,index) in items" :key="index">
                        <!--<v-btn text color="#000">-->
                            <a @click="changeHash('#'+item.id,index)" target="_self"
                               :class="activeMenuIndex==index?'menuBtn menuBtnActive':'menuBtn'"
                               style="text-decoration:none;">{{item.title}}</a>
                        <!--</v-btn>-->
                    </span>
                </v-col>
                <v-col
                        cols="2"
                        align-self="center">
                    <div class="imesBtn" @click="goIMES">
                        iMES登录
                    </div>
                </v-col>
            </v-row>
        </v-container>
        <!--导航栏移动端时样式 start-->
        <v-container class="d-flex d-sm-none justify-space-between">
            <v-row justify="center"
                   no-gutters>
                <v-col
                        align-self="center"
                        cols="6"
                        class="text-left"
                >
                    <img src="https://zzitec-hosp-prd.oss-cn-shanghai.aliyuncs.com/public/zzOfficeWeb/zz_logo%402x.png?OSSAccessKeyId=LTAI3mUS3TOsECzW&Expires=10001590131189&Signature=tbunLtv8LUATGAN0zfzmqEshx7Q%3D"
                         class="heardImg" style="height:2rem;" alt="">
                </v-col>
                <v-col
                        align-self="center"
                        class="text-right"
                        cols="6">
                    <v-menu offset-y>
                        <template v-slot:activator="{ on }">
                            <v-btn
                                    color="#000"
                                    icon
                                    v-on="on"
                            >
                                <v-icon style="font-size:2rem;">menu</v-icon>
                            </v-btn>
                        </template>
                        <v-list>
                            <v-list-item
                                    v-for="(item, index) in items"
                                    :key="index"
                                    @click="changeHash('#'+item.id+'Phone')"
                            >
                                {{item.title}}
                            </v-list-item>
                        </v-list>
                    </v-menu>
                </v-col>
            </v-row>
        </v-container>
        <!--导航栏移动端时样式 end-->

        <!--平台介绍pc start-->
        <v-container fluid id="Introduce"
                     style="background-color:#FAF8FF;"
                     class="d-none d-sm-flex flex-column">

            <v-row justify="center"
                   no-gutters>
                <v-col cols="8" sm="10" md="8" class="d-flex justify-center align-center">
                    <!--<v-row no-gutters justify="center" align="center" v-if="btnIndex==0">-->
                    <!--<v-col cols="3">-->
                    <!--<div class="font-weight-bold mb-5" style="font-size:30px;">-->
                    <!--iMES-iot-->
                    <!--</div>-->
                    <!--<div>-->
                    <!--线上化链接设备在物联网的每一个节点，完美支撑资产管理决策以及效益分析-->
                    <!--</div>-->
                    <!--</v-col>-->
                    <!--<v-col cols="9">-->
                    <!--<img style="width:100%;min-height:25.8vw;"-->
                    <!--src="https://zzitec-hosp-prd.oss-cn-shanghai.aliyuncs.com/public/zzOfficeWeb/iot.gif?OSSAccessKeyId=LTAI3mUS3TOsECzW&Expires=100001590560036&Signature=h939YDLU6j8R4FRg5TSKWhBNit4%3D"-->
                    <!--alt="">-->
                    <!--</v-col>-->
                    <!--</v-row>-->
                    <!--<v-row no-gutters justify="center" align="center" v-if="btnIndex==1">-->
                    <!--<v-col cols="3">-->
                    <!--<div class="font-weight-bold mb-5" style="font-size:30px;">-->
                    <!--iMES-Manage-->
                    <!--</div>-->
                    <!--<div>-->
                    <!--集中式管理、分散化运转，打造高效的医疗设备管理体系，医疗体系责任分明-->
                    <!--</div>-->
                    <!--</v-col>-->
                    <!--<v-col cols="9">-->
                    <!--<img style="width:100%;min-height:25.8vw;"-->
                    <!--src="https://zzitec-hosp-prd.oss-cn-shanghai.aliyuncs.com/public/zzOfficeWeb/manage.gif?OSSAccessKeyId=LTAI3mUS3TOsECzW&Expires=10001590636341&Signature=llEiKVomLRPCXlIlFZgE%2FIfdibk%3D"-->
                    <!--alt="">-->
                    <!--</v-col>-->
                    <!--</v-row>-->
                    <!--<v-row no-gutters justify="center" align="center" v-if="btnIndex==2">-->
                    <!--<v-col cols="3">-->
                    <!--<div class="font-weight-bold mb-5" style="font-size:30px;">-->
                    <!--iMES-Eyes-->
                    <!--</div>-->
                    <!--<div>-->
                    <!--360度闭环设备全端数据监控，实时采集建模，深度洞察及精细化分析并提升产业链效能-->
                    <!--</div>-->
                    <!--</v-col>-->
                    <!--<v-col cols="9">-->
                    <!--<img style="width:100%;min-height:25.8vw;"-->
                    <!--src="https://zzitec-hosp-prd.oss-cn-shanghai.aliyuncs.com/public/zzOfficeWeb/eyes.gif?OSSAccessKeyId=LTAI3mUS3TOsECzW&Expires=1001590636426&Signature=GcDgVi%2FAOCvbsd2qsbDfSQ9zxjQ%3D"-->
                    <!--alt="">-->
                    <!--</v-col>-->
                    <!--</v-row>-->
                    <!--<v-row no-gutters justify="center" align="center" v-if="btnIndex==3">-->
                    <!--<v-col cols="3">-->
                    <!--<div class="font-weight-bold mb-5" style="font-size:30px;">-->
                    <!--iMES-Smarter-->
                    <!--</div>-->
                    <!--<div>-->
                    <!--大数据支撑下的设备全生命周期智能画像、智能流程引擎、智能知识库推荐带来一站式机器人服务-->
                    <!--</div>-->
                    <!--</v-col>-->
                    <!--<v-col cols="9">-->
                    <!--<img style="width:100%;min-height:25.8vw;"-->
                    <!--src="https://zzitec-hosp-prd.oss-cn-shanghai.aliyuncs.com/public/zzOfficeWeb/smarter.gif?OSSAccessKeyId=LTAI3mUS3TOsECzW&Expires=10001590648924&Signature=e28DDlINgjIogznj4qaqnZA3yzk%3D"-->
                    <!--alt="">-->
                    <!--</v-col>-->
                    <!--</v-row>-->


                    <v-carousel
                            v-model="btnIndex"
                            cycle
                            height="auto"
                            hide-delimiters
                            :show-arrows="false"
                            interval="10000"
                    >
                        <v-carousel-item
                        >
                            <v-row no-gutters justify="center" align="center" v-if="btnIndex==0">
                                <v-col cols="3">
                                    <div class="font-weight-bold mb-5" style="font-size:30px;">
                                        iMES-iot
                                    </div>
                                    <div>
                                        线上化链接设备在物联网的每一个节点，完美支撑资产管理决策以及效益分析
                                    </div>
                                </v-col>
                                <v-col cols="9">
                                    <img style="width:100%;min-height:25.8vw;"
                                         src="https://zzitec-hosp-prd.oss-cn-shanghai.aliyuncs.com/public/zzOfficeWeb/iot.gif?OSSAccessKeyId=LTAI3mUS3TOsECzW&Expires=100001590560036&Signature=h939YDLU6j8R4FRg5TSKWhBNit4%3D"
                                         alt="">
                                </v-col>
                            </v-row>
                        </v-carousel-item>
                        <v-carousel-item
                        >
                            <v-row no-gutters justify="center" align="center" v-if="btnIndex==1">
                                <v-col cols="3">
                                    <div class="font-weight-bold mb-5" style="font-size:30px;">
                                        iMES-Manage
                                    </div>
                                    <div>
                                        集中式管理、分散化运转，打造高效的医疗设备管理体系，医疗体系责任分明
                                    </div>
                                </v-col>
                                <v-col cols="9">
                                    <img style="width:100%;min-height:25.8vw;"
                                         src="https://zzitec-hosp-prd.oss-cn-shanghai.aliyuncs.com/public/zzOfficeWeb/manage.gif?OSSAccessKeyId=LTAI3mUS3TOsECzW&Expires=10001590636341&Signature=llEiKVomLRPCXlIlFZgE%2FIfdibk%3D"
                                         alt="">
                                </v-col>
                            </v-row>
                        </v-carousel-item>
                        <v-carousel-item
                        >
                            <v-row no-gutters justify="center" align="center" v-if="btnIndex==2">
                                <v-col cols="3">
                                    <div class="font-weight-bold mb-5" style="font-size:30px;">
                                        iMES-Eyes
                                    </div>
                                    <div>
                                        360度闭环设备全端数据监控，实时采集建模，深度洞察及精细化分析并提升产业链效能
                                    </div>
                                </v-col>
                                <v-col cols="9">
                                    <img style="width:100%;min-height:25.8vw;"
                                         src="https://zzitec-hosp-prd.oss-cn-shanghai.aliyuncs.com/public/zzOfficeWeb/eyes.gif?OSSAccessKeyId=LTAI3mUS3TOsECzW&Expires=1001590636426&Signature=GcDgVi%2FAOCvbsd2qsbDfSQ9zxjQ%3D"
                                         alt="">
                                </v-col>
                            </v-row>
                        </v-carousel-item>
                        <v-carousel-item
                        >
                            <v-row no-gutters justify="center" align="center" v-if="btnIndex==3">
                                <v-col cols="3">
                                    <div class="font-weight-bold mb-5" style="font-size:30px;">
                                        iMES-Smarter
                                    </div>
                                    <div>
                                        大数据支撑下的设备全生命周期智能画像、智能流程引擎、智能知识库推荐带来一站式机器人服务
                                    </div>
                                </v-col>
                                <v-col cols="9">
                                    <img style="width:100%;min-height:25.8vw;"
                                         src="https://zzitec-hosp-prd.oss-cn-shanghai.aliyuncs.com/public/zzOfficeWeb/smarter.gif?OSSAccessKeyId=LTAI3mUS3TOsECzW&Expires=10001590648924&Signature=e28DDlINgjIogznj4qaqnZA3yzk%3D"
                                         alt="">
                                </v-col>
                            </v-row>
                        </v-carousel-item>
                    </v-carousel>


                </v-col>
            </v-row>


            <v-row justify="center"
                   no-gutters>
                <v-col cols="8"
                       md="8"
                       sm="10"
                       class="d-flex justify-space-between align-center">
                    <v-row>
                        <v-col cols="3"
                               md="3"
                               sm="6">
                            <v-btn
                                    min-width="100%"
                                    min-height="70px"
                                    large
                                    :depressed="btnIndex==0?false:true"
                                    :color="btnIndex==0?'rgba(85,20,255,0.54)':'#fff'"
                                    :class="btnIndex==0?'white--text ma-2':'ma-2'"
                                    @click="btnIndex=0"
                                    style="box-shadow:0px 8px 12px 0px rgba(215,200,255,1);text-transform: none;"
                            >
                                <img v-if="btnIndex==0" style="width:25px;height:20px;margin-right:14px;"
                                     src="https://zzitec-hosp-prd.oss-cn-shanghai.aliyuncs.com/public/zzOfficeWeb/iot%402x.png?OSSAccessKeyId=LTAI3mUS3TOsECzW&Expires=100001590559104&Signature=9w7bWkvFbHPzwI7ULOwUv%2F%2B%2FUWM%3D"
                                     alt="">
                                <img v-else style="width:25px;height:20px;margin-right:14px;"
                                     src="https://zzitec-hosp-prd.oss-cn-shanghai.aliyuncs.com/public/zzOfficeWeb/iot2%402x.png?OSSAccessKeyId=LTAI3mUS3TOsECzW&Expires=1001590559482&Signature=%2Bonsayi6vjALnBoK3r1%2BxwxNyfc%3D"
                                     alt="">
                                iMES-iot
                            </v-btn>
                        </v-col>
                        <v-col cols="3"
                               md="3"
                               sm="6">
                            <v-btn
                                    min-width="100%"
                                    min-height="70px"
                                    large
                                    :depressed="btnIndex==1?false:true"
                                    :color="btnIndex==1?'rgba(85,20,255,0.54)':'#fff'"
                                    :class="btnIndex==1?'white--text ma-2':'ma-2'"
                                    @click="btnIndex=1"
                                    style="box-shadow:0px 8px 12px 0px rgba(215,200,255,1);text-transform: none;"
                            >
                                <img v-if="btnIndex==1" style="width:25px;height:20px;margin-right:14px;"
                                     src="https://zzitec-hosp-prd.oss-cn-shanghai.aliyuncs.com/public/zzOfficeWeb/manage%402x.png?OSSAccessKeyId=LTAI3mUS3TOsECzW&Expires=1001590559339&Signature=VD%2BEG3JfcjLGvzdVtNrw0tgfOMA%3D"
                                     alt="">
                                <img v-else style="width:25px;height:20px;margin-right:14px;"
                                     src="https://zzitec-hosp-prd.oss-cn-shanghai.aliyuncs.com/public/zzOfficeWeb/manage2%402x.png?OSSAccessKeyId=LTAI3mUS3TOsECzW&Expires=10001590559528&Signature=%2Fu3ZlrJptQZ%2FzFzIAqmqAgPlPFI%3D"
                                     alt="">
                                iMES-Manage
                            </v-btn>
                        </v-col>
                        <v-col cols="3"
                               md="3"
                               sm="6">
                            <v-btn
                                    min-width="100%"
                                    min-height="70px"
                                    large
                                    :depressed="btnIndex==2?false:true"
                                    :color="btnIndex==2?'rgba(85,20,255,0.54)':'#fff'"
                                    :class="btnIndex==2?'white--text ma-2':'ma-2'"
                                    @click="btnIndex=2"
                                    style="box-shadow:0px 8px 12px 0px rgba(215,200,255,1);text-transform: none;"
                            >
                                <img v-if="btnIndex==2" style="width:25px;height:20px;margin-right:14px;"
                                     src="https://zzitec-hosp-prd.oss-cn-shanghai.aliyuncs.com/public/zzOfficeWeb/eyes%402x.png?OSSAccessKeyId=LTAI3mUS3TOsECzW&Expires=100000001590559630&Signature=mfFvGRsX72aA1b1bB7dhSB3N7HM%3D"
                                     alt="">
                                <img v-else style="width:25px;height:20px;margin-right:14px;"
                                     src="https://zzitec-hosp-prd.oss-cn-shanghai.aliyuncs.com/public/zzOfficeWeb/eyes2%402x.png?OSSAccessKeyId=LTAI3mUS3TOsECzW&Expires=10001590559590&Signature=IU4Zay24HpA0dLOQ6pgQuGOGjBA%3D"
                                     alt="">
                                iMES-Eyes
                            </v-btn>
                        </v-col>
                        <v-col cols="3"
                               md="3"
                               sm="6">
                            <v-btn
                                    min-width="100%"
                                    min-height="70px"
                                    large
                                    :depressed="btnIndex==3?false:true"
                                    :color="btnIndex==3?'rgba(85,20,255,0.54)':'#fff'"
                                    :class="btnIndex==3?'white--text ma-2':'ma-2'"
                                    @click="btnIndex=3"
                                    style="box-shadow:0px 8px 12px 0px rgba(215,200,255,1);text-transform: none;"
                            >
                                <img v-if="btnIndex==3" style="width:25px;height:20px;margin-right:14px;"
                                     src="https://zzitec-hosp-prd.oss-cn-shanghai.aliyuncs.com/public/zzOfficeWeb/smarter%402x.png?OSSAccessKeyId=LTAI3mUS3TOsECzW&Expires=1000001590559726&Signature=zQmI9NPBa0HzIBhbn%2BGB%2B5LABrE%3D"
                                     alt="">
                                <img v-else style="width:25px;height:20px;margin-right:14px;"
                                     src="https://zzitec-hosp-prd.oss-cn-shanghai.aliyuncs.com/public/zzOfficeWeb/smarter2%402x.png?OSSAccessKeyId=LTAI3mUS3TOsECzW&Expires=10001590559694&Signature=payqomTGBHQmUm%2F4WDjTx9y9gV8%3D"
                                     alt="">
                                iMES-Smarter
                            </v-btn>
                        </v-col>
                    </v-row>

                </v-col>
            </v-row>
        </v-container>
        <!--平台介绍pc end-->

        <!--平台介绍移动 start-->
        <v-container fluid id="IntroducePhone" class="d-flex d-sm-none">
            <v-carousel
                    cycle
                    height="auto"
                    hide-delimiters
                    :show-arrows="false"
                    interval="10000"
            >
                <v-carousel-item
                        v-for="(item, i) in bannerSlides"
                        :key="i"
                >
                    <div class="d-flex flex-column align-center">
                        <div class="font-weight-bold mb-2" style="font-size:15px;">
                            {{item.title}}
                        </div>
                        <div class="text-center" style="font-size:13px;">
                            {{item.text}}
                        </div>
                        <div style="width:100%;height:52vw;">
                            <img style="width:100%;height:100%;"
                                 :src="item.imgUrl"
                                 alt="">
                        </div>

                    </div>

                </v-carousel-item>
            </v-carousel>
        </v-container>
        <!--平台介绍移动 end-->

        <!--pc端数字展示部分 start-->
        <v-container fluid id="Features" class="d-none d-sm-flex justify-sm-start">
            <v-row justify="center"
                   no-gutters>
                <v-col cols="8"
                       sm="10"
                       md="8"
                       class="d-flex align-center justify-space-between">
                    <!--用vuetify的image组件华为手机有兼容性问题，所以自己用标签写-->
                    <div class="numView">
                        <img
                                style="width:100%;display:block;"
                                src="https://zzitec-hosp-prd.oss-cn-shanghai.aliyuncs.com/public/zzOfficeWeb/qgsdfw.png?OSSAccessKeyId=LTAI3mUS3TOsECzW&Expires=1001590136194&Signature=ZhXgGCLVT%2FJr6kh%2F69Dyw%2BzXf04%3D"
                                alt="">

                        <div class="numContent">
                            <div>
                                全国深度服务医院
                            </div>
                            <div class="numStyle">
                                <span>{{hosptialSumNum}}</span>
                                <span>+</span>
                            </div>
                        </div>
                    </div>
                    <div class="numView">
                        <img
                                style="width:100%;display:block;"
                                src="https://zzitec-hosp-prd.oss-cn-shanghai.aliyuncs.com/public/zzOfficeWeb/ljgl%402x.png?OSSAccessKeyId=LTAI3mUS3TOsECzW&Expires=1001590137471&Signature=1sQSe6Nun%2Fj6X%2BSadx7wLKNJAjI%3D"
                                alt="">

                        <div class="numContent">
                            <div>
                                累计管理设备总数
                            </div>
                            <div class="numStyle">
                                <span>{{eqpNum}}万</span>
                                <span>+</span>
                            </div>
                        </div>
                    </div>
                    <div class="numView">
                        <img
                                style="width:100%;display:block;"
                                src="https://zzitec-hosp-prd.oss-cn-shanghai.aliyuncs.com/public/zzOfficeWeb/ljgzzcgm%402x.png?OSSAccessKeyId=LTAI3mUS3TOsECzW&Expires=1000001590137518&Signature=JmasJc4G4wCfhGVEI%2FfcdL6SJJw%3D"
                                alt="">

                        <div class="numContent">
                            <div>
                                累计管理资产规模
                            </div>
                            <div class="numStyle">
                                <span>{{assetsNum}}亿</span>
                                <span>+</span>
                            </div>
                        </div>
                    </div>
                </v-col>
            </v-row>
        </v-container>
        <!--pc端数字展示部分 end-->

        <!--移动端数字展示部分 start-->
        <v-container fluid id="FeaturesPhone" class="d-flex d-sm-none justify-space-between">
            <v-row justify="center"
                   no-gutters>
                <v-col cols="12"
                       class="d-flex align-center justify-space-between">
                    <!--用vuetify的image组件华为手机有兼容性问题，所以自己用标签写-->
                    <div class="numView">
                        <img
                                style="width:100%;display:block;"
                                src="https://zzitec-hosp-prd.oss-cn-shanghai.aliyuncs.com/public/zzOfficeWeb/qgsdfw.png?OSSAccessKeyId=LTAI3mUS3TOsECzW&Expires=1001590136194&Signature=ZhXgGCLVT%2FJr6kh%2F69Dyw%2BzXf04%3D"
                                alt="">

                        <div class="numContent">
                            <div style="font-size:0.625rem;">
                                全国深度服务医院
                            </div>
                            <div class="numStyle" style="font-size:1rem;">
                                <span>{{hosptialSumNum}}</span>
                                <span>+</span>
                            </div>
                        </div>
                    </div>
                    <div class="numView">
                        <img
                                style="width:100%;display:block;"
                                src="https://zzitec-hosp-prd.oss-cn-shanghai.aliyuncs.com/public/zzOfficeWeb/ljgl%402x.png?OSSAccessKeyId=LTAI3mUS3TOsECzW&Expires=1001590137471&Signature=1sQSe6Nun%2Fj6X%2BSadx7wLKNJAjI%3D"
                                alt="">

                        <div class="numContent">
                            <div style="font-size:0.625rem;">
                                累计管理设备总数
                            </div>
                            <div class="numStyle" style="font-size:1rem;">
                                <span>{{eqpNum}}万</span>
                                <span>+</span>
                            </div>
                        </div>
                    </div>
                    <div class="numView">
                        <img
                                style="width:100%;display:block;"
                                src="https://zzitec-hosp-prd.oss-cn-shanghai.aliyuncs.com/public/zzOfficeWeb/ljgzzcgm%402x.png?OSSAccessKeyId=LTAI3mUS3TOsECzW&Expires=1000001590137518&Signature=JmasJc4G4wCfhGVEI%2FfcdL6SJJw%3D"
                                alt="">

                        <div class="numContent">
                            <div style="font-size:0.625rem;">
                                累计管理资产规模
                            </div>
                            <div class="numStyle" style="font-size:1rem;">
                                <span>{{assetsNum}}亿</span>
                                <span>+</span>
                            </div>
                        </div>
                    </div>
                </v-col>
            </v-row>
        </v-container>
        <!--移动端数字展示部分 end-->

        <!--pc端智慧医疗 start-->
        <v-container fluid class="d-none flex-column d-sm-flex">
            <v-row justify="center" class="text-center">
                <v-col cols="12"
                       style="font-size:25px;"
                       class="font-weight-bold">
                    iMES智慧医疗设备服务平台
                </v-col>
            </v-row>
            <v-row justify="center"
                   no-gutters>
                <v-col cols="12"
                       class="mt-6 mb-6"
                       md="8"
                       sm="10">
                    <v-row justify="space-between"
                           no-gutters>
                        <v-col cols="12"
                               md="4"
                               sm="6">
                            <div class="pa-5 flex-view-style">
                                <img class="mr-5" style="width:6rem;"
                                     src="https://zzitec-hosp-prd.oss-cn-shanghai.aliyuncs.com/public/zzOfficeWeb/ptdw%402x.png?OSSAccessKeyId=LTAI3mUS3TOsECzW&Expires=1001590375493&Signature=v67Jzdn%2Bb%2FnpE%2B68IoacbaHWsUM%3D"
                                     alt="">
                                <div>
                                    <div style="font-size:20px" class="mb-2 font-weight-bold">平台定位</div>
                                    <div style="font-size:14px;color:#666;">基于医疗设备服务，打造医疗行业领先的数据生态服务平台</div>
                                </div>
                            </div>
                        </v-col>
                        <v-col cols="12"
                               md="4"
                               sm="6">
                            <div class="pa-5 flex-view-style">
                                <img class="mr-5" style="width:6rem;"
                                     src="https://zzitec-hosp-prd.oss-cn-shanghai.aliyuncs.com/public/zzOfficeWeb/ptbz%402x.png?OSSAccessKeyId=LTAI3mUS3TOsECzW&Expires=1001590376628&Signature=IgAv9y8Z8Yn8lBspF3kHJC9kGtU%3D"
                                     alt="">
                                <div>
                                    <div style="font-size:20px" class="mb-2 font-weight-bold">平台标准</div>
                                    <div style="font-size:14px;color:#666;">行业标准化、线上线下一体化、大数据价值化、沟通连接场景化、人工智能产业化</div>
                                </div>
                            </div>
                        </v-col>
                        <v-col cols="12"
                               md="4"
                               sm="6">
                            <div class="pa-5 flex-view-style">
                                <img class="mr-5" style="width:6rem;"
                                     src="https://zzitec-hosp-prd.oss-cn-shanghai.aliyuncs.com/public/zzOfficeWeb/ptzz%402x.png?OSSAccessKeyId=LTAI3mUS3TOsECzW&Expires=1001590376671&Signature=zfawrGAkLjTJpwuHSMMO8eN5lXU%3D"
                                     alt="">
                                <div>
                                    <div style="font-size:20px" class="mb-2 font-weight-bold">平台宗旨</div>
                                    <div style="font-size:14px;color:#666;">我们做的是面向B端客户的C端产品，一切以用户为中心</div>
                                </div>
                            </div>
                        </v-col>
                    </v-row>
                </v-col>
            </v-row>
        </v-container>
        <!--pc端智慧医疗 end-->

        <!--移动端智慧医疗 start-->
        <v-container fluid class="d-flex flex-column d-sm-none">
            <v-row justify="center" class="text-center">
                <v-col cols="12"
                       style="font-size:15px;"
                       class="font-weight-bold">
                    iMES智慧医疗
                </v-col>
            </v-row>
            <v-row justify="center"
                   no-gutters>
                <v-col cols="12"
                       sm="8">
                    <v-row justify="space-between"
                           no-gutters>
                        <v-col cols="12"
                               md="4"
                               sm="6">
                            <div class="pa-5 flex-view-style">
                                <img class="mr-5" style="width:4rem;"
                                     src="https://zzitec-hosp-prd.oss-cn-shanghai.aliyuncs.com/public/zzOfficeWeb/ptdw%402x.png?OSSAccessKeyId=LTAI3mUS3TOsECzW&Expires=1001590375493&Signature=v67Jzdn%2Bb%2FnpE%2B68IoacbaHWsUM%3D"
                                     alt="">
                                <div>
                                    <div style="font-size:12px;" class="mb-2 font-weight-bold">平台定位</div>
                                    <div style="font-size:11px;">基于医疗设备服务，打造医疗行业领先的数据生态服务平台</div>
                                </div>
                            </div>
                        </v-col>
                        <v-col cols="12"
                               md="4"
                               sm="6">
                            <div class="pa-5 flex-view-style">
                                <img class="mr-5" style="width:4rem;"
                                     src="https://zzitec-hosp-prd.oss-cn-shanghai.aliyuncs.com/public/zzOfficeWeb/ptbz%402x.png?OSSAccessKeyId=LTAI3mUS3TOsECzW&Expires=1001590376628&Signature=IgAv9y8Z8Yn8lBspF3kHJC9kGtU%3D"
                                     alt="">
                                <div>
                                    <div style="font-size:12px;" class="mb-2 font-weight-bold">平台标准</div>
                                    <div style="font-size:11px;">行业标准化、线上线下一体化、大数据价值化、沟通连接场景化、人工智能产业化</div>
                                </div>
                            </div>
                        </v-col>
                        <v-col cols="12"
                               md="4"
                               sm="6">
                            <div class="pa-5 flex-view-style">
                                <img class="mr-5" style="width:4rem;"
                                     src="https://zzitec-hosp-prd.oss-cn-shanghai.aliyuncs.com/public/zzOfficeWeb/ptzz%402x.png?OSSAccessKeyId=LTAI3mUS3TOsECzW&Expires=1001590376671&Signature=zfawrGAkLjTJpwuHSMMO8eN5lXU%3D"
                                     alt="">
                                <div>
                                    <div style="font-size:12px;" class="mb-2 font-weight-bold">平台宗旨</div>
                                    <div style="font-size:11px;">我们做的是面向B端客户的C级产品，一切以用户为中心</div>
                                </div>
                            </div>
                        </v-col>
                    </v-row>
                </v-col>
            </v-row>
        </v-container>
        <!--移动端智慧医疗 end-->

        <!--pc服务案例 start-->
        <v-container id="serviceCase" style="background-color:#F9F9F9;" fluid
                     class="d-none flex-column d-sm-flex caseView">
            <v-row>
                <v-col cols="12" class="text-center font-weight-bold"
                       style="font-size:25px;color:#fff;">服务案例
                </v-col>
            </v-row>
            <v-row justify="center">
                <v-col cols="8"
                       md="8"
                       sm="10">
                    <img src="https://zzitec-hosp-prd.oss-cn-shanghai.aliyuncs.com/public/zzOfficeWeb/fwal%402x.png?OSSAccessKeyId=LTAI3mUS3TOsECzW&Expires=1001590390618&Signature=9lu4WHGDgiVLziF5ATcPrn3txIQ%3D"
                         style="width:100%;display:block;" alt="">
                    <div class="font-weight-bold pa-6" style="color:#666;background-color: #fff;">
                        服务案例
                    </div>
                    <div class="userImage">
                        <vueSeamless :data=userImage :class-option="optionCustomer">
                            <ul class="userImageAllWrapper">
                                <li v-for="item in userImage" :key="item.index">
                                    <div class="mb-4 d-flex align-center">
                                        <img :src="item.img1" class="hospitalLogo" alt="">
                                        {{item.hospName1}}
                                    </div>
                                    <div class="d-flex align-center">
                                        <img :src="item.img2" class="hospitalLogo" alt="">
                                        {{item.hospName2}}
                                    </div>
                                </li>
                            </ul>
                        </vueSeamless>
                    </div>
                </v-col>
            </v-row>
        </v-container>
        <!--pc服务案例 end-->

        <!--移动端案例 start-->
        <v-container id="serviceCasePhone" fluid class="d-flex flex-column d-sm-none caseView"
                     style="background-size:cover;">
            <v-row>
                <v-col cols="12" class="text-center font-weight-bold mb-2"
                       style="font-size:15px;color:#fff;">服务案例
                </v-col>
            </v-row>
            <img style="width:35%;display:block;margin:auto;padding:20px 0 30px 0;"
                 src="https://zzitec-hosp-prd.oss-cn-shanghai.aliyuncs.com/public/zzOfficeWeb/200.png?OSSAccessKeyId=LTAI3mUS3TOsECzW&Expires=10001590742294&Signature=V%2BC%2FIyDT4zIt31z95TewiDxmJNU%3D"
                 alt="">
            <!--<v-row justify="center" align="center">-->
            <!--<v-col cols="5" class="mr-2 mb-4 text-center font-weight-bold" style="background-color:#fff;">-->
            <!--<img style="width:20px;height:20px;margin:auto;margin-bottom:10px;margin-top:10px;"-->
            <!--src="https://zzitec-hosp-prd.oss-cn-shanghai.aliyuncs.com/public/zzOfficeWeb/sbdadzh%402x.png?OSSAccessKeyId=LTAI3mUS3TOsECzW&Expires=1001590638736&Signature=%2FIi8XEuvsJrXY2KpX47%2Brneu9JA%3D"-->
            <!--alt="">-->
            <!--<div style="font-size:13px;">设备档案电子化</div>-->
            <!--</v-col>-->
            <!--<v-col cols="5" class="ml-2 mb-4 text-center font-weight-bold" style="background-color:#fff;">-->
            <!--<img style="width:20px;height:20px;margin:auto;margin-bottom:10px;margin-top:10px;"-->
            <!--src="https://zzitec-hosp-prd.oss-cn-shanghai.aliyuncs.com/public/zzOfficeWeb/lcxsh%402x.png?OSSAccessKeyId=LTAI3mUS3TOsECzW&Expires=100001590638920&Signature=FWt2%2BP1ZJfk%2B3Rhg7H%2B2C5BG4dU%3D"-->
            <!--alt="">-->
            <!--<div style="font-size:13px;">管理流程线上化</div>-->
            <!--</v-col>-->
            <!--</v-row>-->
            <!--<v-row justify="center" align="center">-->
            <!--<v-col cols="5" class="mr-2 text-center font-weight-bold" style="background-color:#fff;">-->
            <!--<img style="width:20px;height:20px;margin:auto;margin-bottom:10px;margin-top:10px;"-->
            <!--src="https://zzitec-hosp-prd.oss-cn-shanghai.aliyuncs.com/public/zzOfficeWeb/gzydh%402x.png?OSSAccessKeyId=LTAI3mUS3TOsECzW&Expires=100001590638977&Signature=pcdaKiNJ0PQDEdD6NZoQ0V%2BCSkg%3D"-->
            <!--alt="">-->
            <!--<div style="font-size:13px;">任务跟踪移动化</div>-->
            <!--</v-col>-->
            <!--<v-col cols="5" class="ml-2 text-center font-weight-bold" style="background-color:#fff;">-->
            <!--<img style="width:20px;height:20px;margin:auto;margin-bottom:10px;margin-top:10px;"-->
            <!--src="https://zzitec-hosp-prd.oss-cn-shanghai.aliyuncs.com/public/zzOfficeWeb/bgsjzdh%402x.png?OSSAccessKeyId=LTAI3mUS3TOsECzW&Expires=1000000001590639000&Signature=NUgb7FONg2reZKiynmL1jKpprIA%3D"-->
            <!--alt="">-->
            <!--<div style="font-size:13px;">报告数据自动化</div>-->
            <!--</v-col>-->
            <!--</v-row>-->

        </v-container>
        <div class="userImage d-flex flex-column d-sm-none mt-6">
            <vueSeamless :data=userImage :class-option="optionCustomer">
                <ul class="userImageAllWrapper"
                    style="width:850px;">
                    <li v-for="item in userImage"
                        style="width:140px;margin-right:25px;"
                        :key="item.index">
                        <div class="mb-4 d-flex align-center"
                             style="border:1px solid #E6E6E6;font-size:10px;padding:10px;">
                            <img :src="item.img1" class="hospitalLogo" style="width:25px;height:25px;" alt="">
                            {{item.hospName1}}
                        </div>
                        <div class="d-flex align-center"
                             style="border:1px solid #E6E6E6;font-size:10px;padding:10px;">
                            <img :src="item.img2" class="hospitalLogo" style="width:25px;height:25px;" alt="">
                            {{item.hospName2}}
                        </div>
                    </li>
                </ul>
            </vueSeamless>
        </div>
        <!--移动端案例 end-->


        <!--移动和pc新闻动态 start-->
        <v-container fluid style="background-color:#F9F9F9;">
            <v-row no-gutters>
                <v-col cols="12" class="text-center font-weight-bold mb-2"
                       style="font-size:25px;">新闻动态
                </v-col>
            </v-row>
            <v-row justify="center">
                <v-col cols="12"
                       md="8"
                       sm="10"
                       class="d-flex align-top justify-space-between">
                    <v-row justify="space-between" align-content="stretch" align="start">
                        <v-col
                                cols="12"
                                sm="4">
                            <div>
                                <img src="https://zzitec-hosp-prd.oss-cn-shanghai.aliyuncs.com/public/zzOfficeWeb/xw1.png?OSSAccessKeyId=LTAI3mUS3TOsECzW&Expires=1001590464702&Signature=GD5w5KA%2B%2F3wNsCTYzLTjlZIiJZU%3D"
                                     alt="" style="width:100%;">
                            </div>
                            <div style="color:#666;">
                                <p class="font-weight-bold mb-4 mt-3" style="color:#333;font-size:16px;">
                                    聚焦 | 最美白衣天使</p>
                                <p style="font-size:12px;">
                                    新冠肺炎疫情发生以来，广大"白衣天使"们逆行出征，英勇无畏地投入防控第一线，用实际行动践行敬佑生命、救死扶伤、甘于奉献、大爱无疆的职业精神，你们是"新时代最可爱的人"。
                                    你们将青春定格在燕尾帽下，用奉献丈量着生命的长度，有人称你们白衣天使，其实你们就是我们身边的普通人，或是姐妹，女儿，或是母亲、妻子。你们有一个共同的名字，护士。在第109个"5.12国际护士节"来临之际，为继承和弘扬南丁格尔，不畏艰险、
                                    甘于奉献、救死扶伤、勇于献身的人道主义精神。致敬疫情中坚守的医护人员。
                                </p>
                                <p style="font-size:12px;float:right;">2020-05-20</p>
                            </div>
                        </v-col>
                        <v-col
                                cols="12"
                                sm="4">
                            <div>
                                <img src="https://zzitec-hosp-prd.oss-cn-shanghai.aliyuncs.com/public/zzOfficeWeb/xw2.png?OSSAccessKeyId=LTAI3mUS3TOsECzW&Expires=1001590464739&Signature=hQUlDfO7XhJeOoHwGPgVCXH6tCA%3D"
                                     alt="" style="width:100%;">
                            </div>
                            <div style="color:#666;">
                                <p class="font-weight-bold mb-4 mt-3" style="color:#333;font-size:16px;">
                                    五一 致敬抗疫劳动者</p>
                                <p style="font-size:12px;">
                                    2020年是个特殊的一年，一场突如其来的新型冠状病毒感染的肺炎疫情，让我们的身体健康受到潜在的威胁，也打乱了我们所有人的工作、生活与休息的节奏。
                                    在这个时候，是你们挺身而出，"不计报酬、无论生死"，在抗疫的一线守护着我们。现在疫情得到良好的控制，武汉也解封了，我们也都全面复工，回到正常的生活中。这都离不开你们的默默付出。
                                    在这个五一劳动节，我们想对您说："你们辛苦了..."
                                </p>
                                <p style="font-size:12px;float:right;">2020-05-01</p>
                            </div>
                        </v-col>
                        <v-col
                                cols="12"
                                sm="4">
                            <div>
                                <img src="https://zzitec-hosp-prd.oss-cn-shanghai.aliyuncs.com/public/zzOfficeWeb/xw3.png?OSSAccessKeyId=LTAI3mUS3TOsECzW&Expires=10001590464777&Signature=poR4bXov9nvzuIitrrolOjoNmBE%3D"
                                     alt="" style="width:100%;">
                            </div>
                            <div style="color:#666;">
                                <p class="font-weight-bold mb-4 mt-3" style="color:#333;font-size:16px;">
                                    河南理工大学第一附属医院医疗设备维修中心启用仪式圆满举行</p>
                                <p style="font-size:12px;">
                                    2020年4月28日.上午,焦作市第二人民医院医疗设备维修中心启动仪式圆满举行。焦作市第二人民医院党委书记杨永国、院长于拥军、副院长仝峰、副院长谢向东、纪委书记韩海年、副院长王虹、各相关部门负责人、医学装备部全体工作人员,上海昆亚医疗器械股份有限公司副总经理邵剑英、技术总监徐峰、销售总监范昊、王威以及驻院工程师团队全体成员等共同出席服务中心启动仪式。</p>
                                <p style="font-size:12px;float:right;">2020-04-30</p>
                            </div>
                        </v-col>
                    </v-row>
                </v-col>
            </v-row>
        </v-container>
        <!--移动和pc新闻动态 end-->


        <!--c级产品pc端 start-->
        <v-container fluid class="d-none d-sm-flex bannerView justify-center align-center">
            <v-row>
                <v-col cols="12" class="pa-12"
                       style="font-size:40px;text-align:center;color:#fff;font-weight: bold">
                    面向B端客户的C端产品，一切以用户为中心
                </v-col>
            </v-row>
        </v-container>
        <!--c级产品pc端 end-->

        <!--c级产品移动端 start-->
        <v-container fluid
                     style="height:40vw;"
                     class="d-flex d-sm-none bannerView d-flex justify-center align-center">
            <v-row justify="center">
                <v-col cols="7" style="font-size:15px;text-align:center;color:#fff;font-weight: bold">
                    <p>面向B端客户的C端产品，一切以用户为中心</p>
                </v-col>
            </v-row>
        </v-container>
        <!--c级产品移动端 end-->

        <!--pc端底部 start-->
        <v-container id="CONTACT" class="d-none d-sm-flex pt-12" fluid
                     style="background-color:#140730;color:#fff;">
            <v-row>
                <v-col cols="6" class="d-flex justify-center align-center">
                    <img style="width:300px;height:50px;"
                         src="https://zzitec-hosp-prd.oss-cn-shanghai.aliyuncs.com/public/zzOfficeWeb/copy_logo.png?OSSAccessKeyId=LTAI3mUS3TOsECzW&Expires=1001590547765&Signature=1VDPIaTQQWnV2bGmfaaMEAjznn0%3D"
                         alt="">
                </v-col>
                <v-col cols="6" class="d-flex justify-center align-top">
                    <div class="mr-6">
                        <div class="mb-4">
                            联系我们
                        </div>
                        <div class="d-flex mb-4">
                            <img style="width:20px;height:20px;margin-right:17px;"
                                 src="https://zzitec-hosp-prd.oss-cn-shanghai.aliyuncs.com/public/zzOfficeWeb/wangzhi%402x.png?OSSAccessKeyId=LTAI3mUS3TOsECzW&Expires=1001590549524&Signature=nQAcXdiK%2FjJRnv5QJO%2FFVT9ug90%3D"
                                 alt="">
                            <span class="copy-text">https://www.zzitec.com</span>
                        </div>
                        <div class="d-flex mb-4">
                            <img style="width:20px;height:20px;margin-right:17px;"
                                 src="https://zzitec-hosp-prd.oss-cn-shanghai.aliyuncs.com/public/zzOfficeWeb/youxiang%20%402x.png?OSSAccessKeyId=LTAI3mUS3TOsECzW&Expires=101590551163&Signature=SF00yr9fVty%2Fs0HzdOVcjHjKVS8%3D"
                                 alt="">
                            <span class="copy-text">Email:BD@zzitec.com</span>
                        </div>
                        <div class="d-flex mb-4">
                            <img style="width:20px;height:20px;margin-right:17px;"
                                 src="https://zzitec-hosp-prd.oss-cn-shanghai.aliyuncs.com/public/zzOfficeWeb/dianhua%20%402x.png?OSSAccessKeyId=LTAI3mUS3TOsECzW&Expires=1001590551212&Signature=UeUWbAjxcAxte3jkXIDBxbUAaLA%3D"
                                 alt="">
                            <span class="copy-text">Tel:400-856-0155</span>
                        </div>
                    </div>
                    <div style="margin-left:10px;">
                        <div class="mb-4">
                            iMES公众号
                        </div>
                        <div style="width:100px;height:100px;background-color:#fff;">
                            <img style="width:100%;height:100%;"
                                 src="https://zzitec-hosp-prd.oss-cn-shanghai.aliyuncs.com/public/zzOfficeWeb/imesGZH.jpg?OSSAccessKeyId=LTAI3mUS3TOsECzW&Expires=1001593589299&Signature=NymK15fx7SogTzsDVM5Kr4ssGMg%3D"
                                 alt="">
                        </div>
                    </div>
                    <div style="margin-left:10px;">
                        <div class="mb-4">
                            iMES小程序码
                        </div>
                        <div style="width:100px;height:100px;background-color:#fff;">
                            <img style="width:100%;height:100%;"
                                 src="https://zzitec-hosp-prd.oss-cn-shanghai.aliyuncs.com/public/zzOfficeWeb/xcx.jpg?OSSAccessKeyId=LTAI3mUS3TOsECzW&Expires=1001590740293&Signature=6hOMQ1VAjGMMg2fl%2B23O6afyIyU%3D"
                                 alt="">
                        </div>
                    </div>
                </v-col>
            </v-row>
        </v-container>
        <!--pc端底部 end-->

        <!--移动端底部 start-->
        <v-container id="CONTACTPhone" class="d-flex d-sm-none pt-10 d-flex flex-column align-center" fluid
                     style="background-color:#140730;color:#fff;">
            <img style="width:210px;height:40px;margin-bottom:25px;"
                 src="https://zzitec-hosp-prd.oss-cn-shanghai.aliyuncs.com/public/zzOfficeWeb/copy_logo.png?OSSAccessKeyId=LTAI3mUS3TOsECzW&Expires=1001590547765&Signature=1VDPIaTQQWnV2bGmfaaMEAjznn0%3D"
                 alt="">
            <div class="d-flex justify-center align-center">
                <img style="width:30%;margin-bottom:25px;margin-right:5%;"
                     src="https://zzitec-hosp-prd.oss-cn-shanghai.aliyuncs.com/public/zzOfficeWeb/xcx.jpg?OSSAccessKeyId=LTAI3mUS3TOsECzW&Expires=1001590740293&Signature=6hOMQ1VAjGMMg2fl%2B23O6afyIyU%3D"
                     alt="">
                <img style="width:30%;margin-bottom:25px;margin-left:5%;"
                     src="https://zzitec-hosp-prd.oss-cn-shanghai.aliyuncs.com/public/zzOfficeWeb/imesGZH.jpg?OSSAccessKeyId=LTAI3mUS3TOsECzW&Expires=1001593589299&Signature=NymK15fx7SogTzsDVM5Kr4ssGMg%3D"
                     alt="">
            </div>
            <div class="d-flex mb-4">
                <img style="width:15px;height:15px;margin-right:14px;"
                     src="https://zzitec-hosp-prd.oss-cn-shanghai.aliyuncs.com/public/zzOfficeWeb/wangzhi%402x.png?OSSAccessKeyId=LTAI3mUS3TOsECzW&Expires=1001590549524&Signature=nQAcXdiK%2FjJRnv5QJO%2FFVT9ug90%3D"
                     alt="">
                <span class="copy-text" style="font-size:12px;">https://www.zzitec.com</span>
            </div>
            <div class="d-flex mb-4">
                <img style="width:15px;height:15px;margin-right:14px;"
                     src="https://zzitec-hosp-prd.oss-cn-shanghai.aliyuncs.com/public/zzOfficeWeb/youxiang%20%402x.png?OSSAccessKeyId=LTAI3mUS3TOsECzW&Expires=101590551163&Signature=SF00yr9fVty%2Fs0HzdOVcjHjKVS8%3D"
                     alt="">
                <span class="copy-text" style="font-size:12px;">Email:BD@zzitec.com</span>
            </div>
        </v-container>
        <!--移动端底部 end-->

        <!--底部备案 start-->
        <v-container fluid class="d-flex d-sm-none"
        style="background-color:#140730;color:#939393;">
            <v-row class="text-center">
                <v-col cols="12"
                       class="d-flex justify-center align-center">
                    <img src="@/assets/iconLogo.png" width="20" height="20" style="margin-right:5px;" alt="">
                    <span>上海棕旨医疗科技有限公司</span>
                </v-col>
                <v-col cols="12">沪ICP备19027076号</v-col>
                <v-col cols="12">
                    <a target="_blank" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=31011002005162"
                       style="display:inline-block;text-decoration:none;height:20px;line-height:20px;">
                        <img src="@/assets/copy.png" style="float:left;"/>
                        <p style="float:left;height:20px;line-height:20px;margin: 0px 0px 0px 5px; color:#939393;">
                            沪公网安备31011002005162号
                        </p>
                    </a>
                </v-col>
                <v-col cols="12">
                    <div @click="goRelief"
                         style="display:inline-block;text-decoration:none;height:20px;line-height:20px;cursor: pointer">
                        <p style="float:left;height:20px;line-height:20px;margin: 0px 0px 0px 5px; color:#939393;">
                            隐私政策
                        </p>
                    </div>
                </v-col>
            </v-row>
        </v-container>

        <v-container fluid class="d-none d-sm-flex pt-12"
                     style="background-color:#140730;color:#fff;">
            <div style="color:#939393;width:100%;"
                 class="d-flex justify-center">
                <p class="d-flex justify-center align-center">
                    <img src="@/assets/iconLogo.png" width="20" height="20" style="margin-right:5px;" alt="">
                    上海棕旨医疗科技有限公司
                </p>
                <p style="margin-left:20px;margin-right:20px;">
                    沪ICP备19027076号
                </p>
                <a target="_blank" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=31011002005162"
                   style="display:inline-block;text-decoration:none;height:20px;line-height:20px;">
                    <img src="@/assets/copy.png" style="float:left;"/>
                    <p style="float:left;height:20px;line-height:20px;margin: 0px 0px 0px 5px; color:#939393;">
                        沪公网安备31011002005162号
                    </p>
                </a>
                <div @click="goRelief"
                   style="display:inline-block;text-decoration:none;height:20px;margin-left:10px;line-height:20px;cursor: pointer">
                    <p style="float:left;height:20px;line-height:20px;margin: 0px 0px 0px 5px; color:#939393;">
                        隐私政策
                    </p>
                </div>
            </div>
        </v-container>
        <!--底部备案 end-->

    </div>
</template>

<script>
  import {imgVerify, hospUserLogin} from '@/api/login'
  import scrypt from '@/utils/scrypt'
  import {
    submitMcht
  } from "@/api/home"
  import NumberAnimate from "@/utils/numberAnimate.js";
  import vueSeamless from 'vue-seamless-scroll'

  export default {
    name: "home",
    data() {
      return {
        btnIndex: 0,
        optionCustomer: {
          step: 1,
          limitMoveNum: 5,
          openTouch: false,
          waitTime: 1,
          direction: 2,
          singleWidth: 30
        },
        userImage: [
          {
            hospName1: '上海市同仁医院',
            img1: "https://zzitec-hosp-prd.oss-cn-shanghai.aliyuncs.com/public/zzOfficeWeb/shtr%402x.png?OSSAccessKeyId=LTAI3mUS3TOsECzW&Expires=1001590471307&Signature=JW1K1dOXRqpYa2pB6wx2lGxZqsc%3D",
            hospName2: '广州市番禺中心医院',
            img2: "https://zzitec-hosp-prd.oss-cn-shanghai.aliyuncs.com/public/zzOfficeWeb/panyu.png?OSSAccessKeyId=LTAI3mUS3TOsECzW&Expires=1001590472926&Signature=BqCBuXKC3VFGiUY3VJvPUFgKT%2Bs%3D",
          },
          {
            hospName1: '北京市昌平区中西医结合医院',
            img1: 'https://zzitec-hosp-prd.oss-cn-shanghai.aliyuncs.com/public/zzOfficeWeb/cpzx%402x.png?OSSAccessKeyId=LTAI3mUS3TOsECzW&Expires=1001590471513&Signature=6Az5QuyDOsTo1vQQxSVCpPJJBzE%3D',
            hospName2: '威海市中心医院',
            img2: 'https://zzitec-hosp-prd.oss-cn-shanghai.aliyuncs.com/public/zzOfficeWeb/whszx%402x.png?OSSAccessKeyId=LTAI3mUS3TOsECzW&Expires=1001590471543&Signature=16U8VVN2tQ2HgQvqgZzFEcdf5%2FQ%3D',
          },
          {
            hospName1: '华北石油管理局总医院',
            img1: 'https://zzitec-hosp-prd.oss-cn-shanghai.aliyuncs.com/public/zzOfficeWeb/hbsy%402x.png?OSSAccessKeyId=LTAI3mUS3TOsECzW&Expires=1001590472225&Signature=0sGcsyNAxp%2F%2Fm4g6%2BHwN%2BCrlMco%3D',
            hospName2: '郑州市人民医院',
            img2: 'https://zzitec-hosp-prd.oss-cn-shanghai.aliyuncs.com/public/zzOfficeWeb/zzsrm%402x.png?OSSAccessKeyId=LTAI3mUS3TOsECzW&Expires=1001590472478&Signature=MDAwm5LJcCh7936dj4%2BOmJOBddI%3D'
          },
          {
            hospName1: '三松医疗集团',
            img1: 'https://zzitec-hosp-prd.oss-cn-shanghai.aliyuncs.com/public/zzOfficeWeb/ssyl%402x.png?OSSAccessKeyId=LTAI3mUS3TOsECzW&Expires=1001590472506&Signature=wMSqTHOOTBiXQR89kxIASvbmpjU%3D',
            hospName2: '安徽省立医院',
            img2: 'https://zzitec-hosp-prd.oss-cn-shanghai.aliyuncs.com/public/zzOfficeWeb/ahsl%402x.png?OSSAccessKeyId=LTAI3mUS3TOsECzW&Expires=1001590472542&Signature=QubeROeFcKDG2rB2b8epE9GnR30%3D'
          },
          {
            hospName1: '广州市中西医结合医院',
            img1: 'https://zzitec-hosp-prd.oss-cn-shanghai.aliyuncs.com/public/zzOfficeWeb/gzzx%402x.png?OSSAccessKeyId=LTAI3mUS3TOsECzW&Expires=1001590472574&Signature=gZZMB7ZiI5YUGjME0zKe1h9RQqg%3D',
            hospName2: '郴州市第一人民医院',
            img2: 'https://zzitec-hosp-prd.oss-cn-shanghai.aliyuncs.com/public/zzOfficeWeb/binzhou%402x.png?OSSAccessKeyId=LTAI3mUS3TOsECzW&Expires=1001590472607&Signature=J%2FD%2FyByxVpAfWW1gyx0aiB9YGZk%3D'
          }
        ],
        activeMenuIndex: 0,
        hosptialSumNum: 200,
        eqpNum: 100,
        assetsNum: 100,
        basicInfo: {
          mchtNm: '',
          mchtAddb: '',
          mchtContact: '',
          mchtContactPhone: '',
          txnTypeNo: "2010100333",
          dataSourceFaly: '03',
          invitationCode: ''
        },
        dialog: {
          contact: false,
          result: false
        },
        loading: {
          submitLoading: false
        },
        isShowFrame: false,
        list: [
          {
            title: 'Merchant Wallet',
            content: [
              'Reload  Wallet',
              'Purchase using Merchant Wallet',
              'Increase Cash Flow',
            ]
          },
          {
            title: 'Merchant to Merchant',
            content: [
              'Connected M2M Merchant',
              'Sharing each other voucher',
              'Earn Cash Back'
            ]
          },
          {
            title: 'Visa Master',
            content: [
              'Visa Card',
              'Master Card',
              'Pay Wave'
            ]
          },
          {
            title: 'E- Menu',
            content: [
              'User scan QR code for order/purchase',
              'User make payment through APP'
            ]
          },
          {
            title: 'Food Delivery Service',
            content: [
              'By using E-Menu, weprovide delivery door',
              'to door'
            ]
          },
          {
            title: 'Business to Customer(B2C)',
            content: [
              'Promote your products from offline to online',
              'Promote your products to Nationwide'
            ]
          },
        ],
        items: [
          {
            title: '平台介绍',
            id: 'Introduce'
          },
          {
            title: '产品介绍',
            id: 'Features'
          },
          {
            title: '服务案例',
            id: 'serviceCase'
          },
          {
            title: '联系我们',
            id: 'CONTACT'
          },
        ],
        colors: [
          'indigo',
          'warning',
          'pink darken-2',
          'red lighten-1',
          'deep-purple accent-4',
        ],
        slides: [
          'First',
          'Second',
          'Third',
          'Fourth',
          'Fifth',
        ],
        bannerSlides: [
          {
            title: 'iMES-iot',
            text: '线上化链接设备在物联网的每一个节点，完美支撑资产管理决策以及效益分析',
            imgUrl: 'https://zzitec-hosp-prd.oss-cn-shanghai.aliyuncs.com/public/zzOfficeWeb/iot.gif?OSSAccessKeyId=LTAI3mUS3TOsECzW&Expires=100001590560036&Signature=h939YDLU6j8R4FRg5TSKWhBNit4%3D'
          },
          {
            title: 'iMES-Manage',
            text: '集中式管理、分散化运转，打造高效的医疗设备管理体系，医疗体系责任分明',
            imgUrl: 'https://zzitec-hosp-prd.oss-cn-shanghai.aliyuncs.com/public/zzOfficeWeb/manage.gif?OSSAccessKeyId=LTAI3mUS3TOsECzW&Expires=10001590636341&Signature=llEiKVomLRPCXlIlFZgE%2FIfdibk%3D'
          },
          {
            title: 'iMES-Eyes',
            text: '360度闭环设备全端数据监控，实时采集建模，深度洞察及精细化分析并提升产业链效能',
            imgUrl: 'https://zzitec-hosp-prd.oss-cn-shanghai.aliyuncs.com/public/zzOfficeWeb/eyes.gif?OSSAccessKeyId=LTAI3mUS3TOsECzW&Expires=1001590636426&Signature=GcDgVi%2FAOCvbsd2qsbDfSQ9zxjQ%3D'
          },
          {
            title: 'iMES-Smarter',
            text: '大数据支撑下的设备全生命周期智能画像、智能流程引擎、智能知识库推荐带来一站式机器人服务',
            imgUrl: 'https://zzitec-hosp-prd.oss-cn-shanghai.aliyuncs.com/public/zzOfficeWeb/smarter.gif?OSSAccessKeyId=LTAI3mUS3TOsECzW&Expires=10001590648924&Signature=e28DDlINgjIogznj4qaqnZA3yzk%3D'
          }
        ]
      }
    },
    computed: {},
    components: {
      vueSeamless
    },
    methods: {
      goRelief(){
        let newUrl = this.$router.resolve({
          path: "/relief"
        });
        window.open(newUrl.href, "_blank");
      },
      // 动态更新数字的方法
      updateSumNumber(number, name) {
        var n1 = new NumberAnimate({
          from: number, //开始时的数字
          speed: 2000, // 总时间
          refreshTime: 100, // 刷新一次的时间
          decimals: 0, //小数点后的位数
          onUpdate: () => { //更新回调函数
            this[name] = n1.tempValue;
          },
          onComplete: () => { //完成回调函数

          }
        });
      },
      goIMES() {
        window.location.href = 'http://hosp.zzitec.com';
      },
      changeHash(idName, index) {
        document.querySelector(idName).scrollIntoView(true);
        this.activeMenuIndex = index;
      },
      submitInfo() {
        if (this.$refs.form.validate()) {
          console.log(this.basicInfo, '用户提交的信息');
          this.loading.submitLoading = true;
          submitMcht(this.basicInfo).then(res => {
            this.loading.submitLoading = false;
            this.dialog.result = true;
          }).catch(err => {
            this.loading.submitLoading = false;
          });
        }
      },
      closeResult() {
        this.dialog.result = false;
        this.$refs.form.reset();
        document.documentElement.scrollTop = 0;
      },
      dialogBtn() {
        this.dialog.contact = false;
        this.changeHash('#CONTACT');
      },
      getQueryVariable(variable) {
        var query = window.location.href;
        var vars = query.split("?");
        for (var i = 0; i < vars.length; i++) {
          var pair = vars[i].split("=");
          if (pair[0] == variable) {
            return pair[1];
          }
        }
        return (false);
      }
    }
    ,
    mounted() {
      // 全国深度服务医院
      this.updateSumNumber(200, 'hosptialSumNum');
      // 累计管理设备总数
      this.updateSumNumber(100, 'eqpNum');
      // 累计管理资产规模
      this.updateSumNumber(100, 'assetsNum');

    }
    ,
    created() {

    }
  }
</script>

<style scoped>
    @import '../../style/animate.min.css';

    .headerStyle {
        background-color: #393939;
        color: #fff;
    }

    .heardImg {
        height: 3rem;
        display: inline-block;
        position: relative;
        top: 3px;
        margin: auto;
    }

    .bannerLeft {
        background-image: url('../../assets/banner1.png');
        background-size: cover;
        background-position: center right;
    }

    .bannerRight {
        background-image: url('../../assets/banner2.png');
        background-size: cover;
        background-position: center left;
    }

    .f-s-title {
        font-size: 1.5rem;
    }

    .primary-color {
        color: #F69D42;
    }

    .gapView {
        background-image: url("../../assets/o2o_bg@2x.png");
        background-size: cover;
        background-position: center center;
        background-repeat: no-repeat;
        min-height: 400px;
    }

    .contactView {
        background-image: url("../../assets/contact.png");
        background-size: cover;
        background-position: center center;
        background-repeat: no-repeat;
    }

    .boderStyle {
        border: 1px solid #B9B9B9;
    }

    .wordNormal {
        word-break: normal;
    }

    .imesBtn {
        background-image: linear-gradient(to right, #444FED, #9B6DD5);
        width: 7rem;
        text-align: center;
        border-radius: 2px;
        color: #fff;
        padding: 0.3rem;
        cursor: pointer;
        margin: auto;
    }

    .menuBtn {
        font-size: 1rem;
        padding-top: 1rem;
        padding-bottom: 0.5rem;
        display: inline-block;
        color: #333;
    }

    .menuBtnActive {
        color: #5514FF;
        border-bottom: 3px solid #5514FF;
        font-weight: 500;
    }

    .numView {
        width: 33%;
        background-color: blue;
        text-align: center;
        color: #fff;
        position: relative;
    }

    .numContent {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
    }

    .numStyle {
        font-size: 50px;
    }

    .caseView {
        background-image: url("https://zzitec-hosp-prd.oss-cn-shanghai.aliyuncs.com/public/zzOfficeWeb/fwal_bg%402x.png?OSSAccessKeyId=LTAI3mUS3TOsECzW&Expires=1001590390230&Signature=9by%2F%2BcKzjy4jL%2F4HKZmQ0zFzu2s%3D");
        background-size: contain;
        background-position: top;
        background-repeat: no-repeat;
    }

    .box {
        width: 100%;
        height: 100%;
    }

    .person-wrap {
        overflow: hidden;
        height: 38px;
    }

    .person-wrap .person-list {
        list-style-type: none;
    }

    .person-wrap .person-list .person-item {
        float: left;
        line-height: 36px;
        margin: 0 16px;
        white-space: nowrap;
    }

    .person-wrap .person-list .current {
        color: #004299;
        border-bottom: 2px solid #004299;
    }

    .wrapper {
        height: 600px;
        background: pink;
        overflow: hidden;
    }

    .wrapper .content {
        display: block;
    }

    .wrapper .content div {
        height: 200px;
        border-bottom: 1px solid red;
        text-align: center;
        line-height: 200px;
    }

    .wrapper .content div :last-of-type {
        height: 600px;
    }

    .userImage {
        overflow: hidden;
        background-color: #fff;
    }

    .userImageAllWrapper {
        width: 1130px;
        list-style: none;
        display: flex;
        flex-wrap: wrap;
    }

    .userImageAllWrapper:last-child {
        /*margin-left: -40px;*/
    }

    li {
        width: 170px;
        margin-right: 50px;
        margin-bottom: 20px;
        /*padding: 10px 30px;*/
        /*border: 1px solid #ECECEC;*/
        font-size: 15px;
        color: #333;
        font-weight: bold;
    }

    img {
        display: flex;
    }

    .newContent {
        width: 32%;
    }

    .hospitalLogo {
        margin-right: 10px;
        width: 50px;
        height: 50px;
        flex-shrink: 0
    }

    .bannerView {
        width: 100%;
        height: 20vw;
        background-image: url("https://zzitec-hosp-prd.oss-cn-shanghai.aliyuncs.com/public/zzOfficeWeb/ggy_bg%402x.png?OSSAccessKeyId=LTAI3mUS3TOsECzW&Expires=1001590485594&Signature=oasQdm8Le9OGjZcAhfORcuqYCPE%3D");
        background-size: 100% 100%;
        background-position: center;
        background-repeat: no-repeat;
        transition: background-size 500ms linear;
    }

    .bannerView:hover {
        background-size: 110% 110%;
    }

    .copy-text {
        font-size: 14px;
        color: #fff;
    }
</style>